import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-index"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "toolbar-button-text" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "toolbar-button-text",
  style: {"text-align":"left"}
}

import vue from '../../../adapter-vue';
import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel
} from '../../../@aidesk/uikit-engine';
import { isH5 } from '../../../utils/env';
import { ToolbarButtonModel } from '../../../interface';
import Icon from '../../common/Icon.vue';
import { TOOLBAR_BUTTON_TYPE } from '../../../constant';
import { isEnabledMessageReadReceiptGlobal, openSafeUrl, getTo, isNonEmptyObject, transferToTaskFlow, transferToHuman, debounce, leaveQueuing } from '../../../utils/utils';
import ToolbarButtonHumanService from './toolbar-button-human-service.vue';
import ToolbarButtonServiceRating from './toolbar-button-service-rating.vue';
import ToolbarButtonEndHumanService from './toolbar-button-end-human-service.vue';
import ToolMoreIcon from '../../../assets/tool_more.svg';
import Log from '../../../utils/logger';
interface IProps {
  toolbarButtonList?: ToolbarButtonModel[] | undefined;
}

const overflowButtonWidth = 38;


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    toolbarButtonList: {}
  },
  setup(__props: any) {

const { ref, onMounted, onUnmounted, computed } = vue;
const props = __props;

const isInHumanService = ref(false);
const currentConversation = ref<IConversationModel>();
const canEndConversation = ref(false);
const queueNumber = ref(-1);
const visibleCount = ref(props.toolbarButtonList ? props.toolbarButtonList.length : 0);
const showPopover = ref(false);

const toolbarContainerRef = ref<HTMLElement | null>(null);
const toolbarWrappersRef = ref<HTMLElement[] | HTMLElement | null>(null);
const toolbarOverflowRef = ref<HTMLElement | null>(null);
const toolbarPopoverRef = ref<HTMLElement | null>(null);
const measureOverflowRef = ref<HTMLElement | null>(null);

const buttonWidthList = ref<number[]>([]);
let resizeObserver: ResizeObserver | null = null;
let mutationObserver: MutationObserver | null = null;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  TUIStore.watch(StoreName.CUSTOM, {
    isInHumanService: onInHumanServiceUpdate,
    canEndConversation: onCanEndConversationUpdate,
    isQueuing: onIsQueuingUpdate,
  });
  getHiddenList();

  try {
    if (typeof (window as any).ResizeObserver !== 'undefined') {
      resizeObserver = new (window as any).ResizeObserver(() => {
        getHiddenList();
        showPopover.value = false;
      });
      if (resizeObserver && toolbarContainerRef.value) {
        resizeObserver.observe(toolbarContainerRef.value);
      }
    } else {
      window.addEventListener('resize', getHiddenList);
    }
    if (typeof MutationObserver !== 'undefined' && toolbarContainerRef.value) {
      mutationObserver = new MutationObserver(() => getHiddenList());
      mutationObserver.observe(toolbarContainerRef.value, { childList: true, subtree: true });
    }
  } catch (e) {
    window.addEventListener('resize', getHiddenList);
  }

  document.addEventListener('click', closePopoverOutside);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  TUIStore.unwatch(StoreName.CUSTOM, {
    isInHumanService: onInHumanServiceUpdate,
    canEndConversation: onCanEndConversationUpdate,
    isQueuing: onIsQueuingUpdate,
  });
  if (resizeObserver) {
    try { 
      resizeObserver.disconnect(); 
    } catch {
      Log.w('ResizeObserver disconnect failed');
    }
    resizeObserver = null;
  }
  if (mutationObserver) {
    try { 
      mutationObserver.disconnect(); 
    } catch {
      Log.w('MutationObserver disconnect failed');
    }
    mutationObserver = null;
  }
  window.removeEventListener('resize', getHiddenList);
  document.removeEventListener('click', closePopoverOutside);
});

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
}

const onInHumanServiceUpdate = (data: {conversationID: string, value: boolean}) => {
  if (data && data.conversationID === currentConversation.value.conversationID) {
    isInHumanService.value = data.value;
    if (!mutationObserver) {
      getHiddenList();
    }
  }
};

const onCanEndConversationUpdate = (data: {conversationID: string, value: boolean}) => {
  if (data && data.conversationID === currentConversation.value.conversationID) {
    canEndConversation.value = data.value;
    if (!mutationObserver) {
      getHiddenList();
    }
  }
}

const onIsQueuingUpdate = (data: {conversationID: string, value: number}) => {
  if (data && data.conversationID === currentConversation.value.conversationID) {
    queueNumber.value = data.value;
  }
}

const closePopover = () => {
  showPopover.value = false;
}

const onClick = debounce((item:ToolbarButtonModel, index: number) => {
  if (!currentConversation.value) {
    return;
  }
  if (item.type === 1 && item.content) {
    TUIChatService.sendTextMessage({
      to: getTo(currentConversation.value),
      conversationType: currentConversation.value.type,
      payload: {
        text: item.content
      },
      needReadReceipt: isEnabledMessageReadReceiptGlobal(),
    });
  } else if (item.type === 2  && item.content) {
    openSafeUrl(item.content);
  } else if (item.type === 3 && isNonEmptyObject(item.content)) {
    transferToTaskFlow(getTo(currentConversation.value), item.content.taskFlowID, item.content.description);
  } else if (item.type === 4 && isNonEmptyObject(item.content)) {
    transferToHuman(getTo(currentConversation.value), item.content.groupID, item.content.specificMemberList, item.content.description);
  } else if (item.type === 5 && queueNumber.value >= 0) {
    leaveQueuing(getTo(currentConversation.value));
  } else if (props.toolbarButtonList !== undefined && typeof props.toolbarButtonList[index].clickEvent === 'function') {
    props.toolbarButtonList[index].clickEvent();
  }
  showPopover.value = false;
}, 300);

const shouldRender = (item: ToolbarButtonModel) => {
  if (item.isEnabled === 1) {
    if (item.type === 5) {
      // 转人工排队人数＜0则不展示
      if (queueNumber.value < 0) {
        return false;
      }
      return true;
    }
    return true;
  } else if (item.isEnabled === 0) {
    return false;
  } else if (item.renderCondition) {
    return typeof item.renderCondition === 'function' ? item.renderCondition() : false;
  }
  return false;
}

const togglePopover = () => {
  showPopover.value = !showPopover.value;
};

const hiddenItems = computed(() => {
  if (props.toolbarButtonList) {
    return props.toolbarButtonList.slice(visibleCount.value) || [];
  }
  return [];
})

const getVisibleCount = () => {
  const list = props.toolbarButtonList || [];
  const buttonCount = list.length;
  const container = toolbarContainerRef.value;
  if (!container) {
    visibleCount.value = buttonCount;
    return;
  }
  const requiredRightGap = 11;
  const available = container.clientWidth - requiredRightGap;
  let sum = 0;
  let visible = 0;
  for (let i = 0; i < buttonCount; i++) {
    const w = buttonWidthList.value[i] || 0;
    if (i < buttonCount - 1) {
      if (sum + w + overflowButtonWidth <= available) {
        sum += w;
        visible++;
      } else {
        break;
      }
    } else {
      if (sum + w <= available) {
        sum += w;
        visible++;
      } else {
        break;
      }
    }
  }  
  if (visible === 0 && buttonCount > 0) {
    visibleCount.value = 0;
  } else {
    visibleCount.value = visible;
  }
  updatePopoverPosition();
};

const getHiddenList = debounce(() => {
  const container = toolbarContainerRef.value;
  if (!container) {
    return;
  }

  const wrappersRaw = toolbarWrappersRef.value;
  const buttonList = Array.isArray(wrappersRaw) ? wrappersRaw : (wrappersRaw ? [wrappersRaw] : []);
  const list = props.toolbarButtonList || [];
  const newWidths: number[] = [];

  for (let i = 0; i < list.length; i++) {
    const el = buttonList[i] as HTMLElement | undefined;
    if (el && typeof el.getBoundingClientRect === 'function') {
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      const ml = parseFloat(style.marginLeft || '0');
      const mr = parseFloat(style.marginRight || '0');
      newWidths[i] = rect.width + ml + mr;
    } else {
      newWidths[i] = 0;
    }
  }
  buttonWidthList.value = newWidths;
  getVisibleCount();
}, 100);

const closePopoverOutside = (e: MouseEvent) => {
  const pop = toolbarPopoverRef.value;
  const btn = toolbarOverflowRef.value;
  if (!pop) {
    return;
  }
  const target = e.target as Node | null;
  if (!target) {
    return;
  }
  if (pop.contains(target) || (btn && btn.contains(target))) {
    return;
  }
  showPopover.value = false;
};

const updatePopoverPosition = () => {
  const pop = toolbarPopoverRef.value;
  const btn = toolbarOverflowRef.value;
  if (!btn) {
    return;
  }
  const btnRect = btn.getBoundingClientRect();
  if (pop) {
    const left = btnRect.right - pop.offsetWidth;
    const top = btnRect.top - pop.offsetHeight - 6; 
    pop.style.left = `${left}px`;
    pop.style.top = `${top}px`;
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "toolbar-button-container",
    ref_key: "toolbarContainerRef",
    ref: toolbarContainerRef
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.toolbarButtonList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['toolbar-item-wrapper', index >= _unref(visibleCount) ? 'measure-offscreen' : '']),
        "data-index": index,
        ref_for: true,
        ref_key: "toolbarWrappersRef",
        ref: toolbarWrappersRef
      }, [
        (item.presetId === _unref(TOOLBAR_BUTTON_TYPE).HUMAN_SERVICE && shouldRender(item) && !_unref(isInHumanService))
          ? (_openBlock(), _createBlock(ToolbarButtonHumanService, {
              key: 0,
              title: item.title,
              icon: item.icon
            }, null, 8, ["title", "icon"]))
          : (item.presetId === _unref(TOOLBAR_BUTTON_TYPE).SERVICE_RATING && shouldRender(item) && _unref(isInHumanService))
            ? (_openBlock(), _createBlock(ToolbarButtonServiceRating, {
                key: 1,
                title: item.title,
                icon: item.icon
              }, null, 8, ["title", "icon"]))
            : (item.presetId === _unref(TOOLBAR_BUTTON_TYPE).END_HUMAN_SERVICE && shouldRender(item) && ((item.displayFlag === 1 && _unref(canEndConversation)) || _unref(isInHumanService)))
              ? (_openBlock(), _createBlock(ToolbarButtonEndHumanService, {
                  key: 2,
                  title: item.title,
                  icon: item.icon
                }, null, 8, ["title", "icon"]))
              : (shouldRender(item) && !item.presetId)
                ? (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(['toolbar-button', _unref(isH5) ? 'toolbar-button-h5' : '']),
                    onClick: ($event: any) => (_unref(onClick)(item, index))
                  }, [
                    (item.icon)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          class: "toolbar-button-icon",
                          file: item.icon,
                          width: "14px",
                          height: "14x"
                        }, null, 8, ["file"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1)
                  ], 10, _hoisted_2))
                : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    }), 128)),
    (_unref(hiddenItems).length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "toolbar-button overflow-button",
          ref_key: "toolbarOverflowRef",
          ref: toolbarOverflowRef,
          onClick: togglePopover
        }, [
          _createVNode(Icon, {
            file: _unref(ToolMoreIcon),
            width: "14px",
            height: "14px"
          }, null, 8, ["file"])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['overflow-popover', _unref(showPopover) ? 'show-popover' : '' ]),
      ref_key: "toolbarPopoverRef",
      ref: toolbarPopoverRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hiddenItems), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id || ('hidden-' + index)
        }, [
          (item.presetId === _unref(TOOLBAR_BUTTON_TYPE).HUMAN_SERVICE && shouldRender(item) && !_unref(isInHumanService))
            ? (_openBlock(), _createBlock(ToolbarButtonHumanService, {
                key: 0,
                class: "overflow-popover-item",
                title: item.title,
                icon: item.icon,
                onClosePopover: closePopover
              }, null, 8, ["title", "icon"]))
            : (item.presetId === _unref(TOOLBAR_BUTTON_TYPE).SERVICE_RATING && shouldRender(item) && _unref(isInHumanService))
              ? (_openBlock(), _createBlock(ToolbarButtonServiceRating, {
                  key: 1,
                  class: "overflow-popover-item",
                  title: item.title,
                  icon: item.icon,
                  onClosePopover: closePopover
                }, null, 8, ["title", "icon"]))
              : (item.presetId === _unref(TOOLBAR_BUTTON_TYPE).END_HUMAN_SERVICE && shouldRender(item) && ((item.displayFlag === 1 && _unref(canEndConversation)) || _unref(isInHumanService)))
                ? (_openBlock(), _createBlock(ToolbarButtonEndHumanService, {
                    key: 2,
                    class: "overflow-popover-item",
                    title: item.title,
                    icon: item.icon,
                    onClosePopover: closePopover
                  }, null, 8, ["title", "icon"]))
                : (shouldRender(item))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "overflow-popover-item",
                      onClick: ($event: any) => (_unref(onClick)(item, _unref(visibleCount) + index))
                    }, [
                      (item.icon)
                        ? (_openBlock(), _createBlock(Icon, {
                            key: 0,
                            class: "toolbar-button-icon",
                            file: item.icon,
                            width: "16px",
                            height: "16px"
                          }, null, 8, ["file"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1)
                    ], 8, _hoisted_4))
                  : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: "measure-offscreen",
      ref_key: "measureOverflowRef",
      ref: measureOverflowRef
    }, "···", 512)
  ], 512))
}
}

})